import React, { Component } from 'react';
import { Checkbox } from '@checkmarx/cx-ui';

export default class ControlledCheckbox extends Component {
    
    toggleCheckbox = () => {
        
        this.props.onCheck(this.props.dataKey);
    }
    
    render() {
        
        return (
            <div>
                <Checkbox
                    checked={this.props.checked}
                    onChange={this.toggleCheckbox}
                    disabled={this.props.disabled}
                    text={this.props.text}
                />
            </div>
        );
    }
}